export const formatAddress = (
  address: string | undefined,
  characters: number = 37
) => {
  return address ? `${address.slice(0, 5)}...${address.slice(characters)}` : ''
}
